import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import uuid from 'react-uuid';
import { encode as base64Encode } from 'base-64';

const getVal = require('lodash/get');

/* eslint-disable no-restricted-syntax -- need */
export const getCookie = (name) => {
  const re = new RegExp(`${name}=([^;]+)`);
  const value = re.exec(document.cookie);
  return value != null ? unescape(value[1]) : null;
};

export const groupIds = (groups, dataObject) => {
  const groupedData = {};
  groups.forEach((group) => {
    const { dynamicIdsFrom, groupName, staticIdsFrom } = group;
    if (dynamicIdsFrom) {
      const idsToGroup = getVal(dataObject, dynamicIdsFrom) || [];
      if (idsToGroup.length > 0) {
        groupedData[groupName] = {};
        const { idValuesFrom } = group;
        idsToGroup.forEach((id) => {
          const idValObject = getVal(dataObject, idValuesFrom);
          const idVal = idValObject ? idValObject[id] : null;
          if (idVal || (!idVal && typeof idVal === 'boolean')) {
            groupedData[groupName][id] = idVal;
          }
        });
      }
    } else if (staticIdsFrom) {
      // extend this to add static ids from JSON under a group
    }
  });
  return groupedData;
};
export const stringifyObjectValues = (dataObject) => {
  const stringifiedObject = { ...dataObject };
  Object.keys(stringifiedObject).forEach((key) => {
    if (stringifiedObject[key] !== null) {
      if (typeof stringifiedObject[key] === 'object') {
        stringifiedObject[key] = JSON.stringify(stringifiedObject[key]);
      }
    }
  });
  return stringifiedObject;
};

const getRegexMap = () => {
  const rexMap = new Map();
  rexMap.set('pdf', /(\.pdf)$/i);
  rexMap.set('xlsx', /(\.xlsx)$/i);
  rexMap.set('png', /(\.png)$/i);
  rexMap.set('tif', /(\.tif)$/i);
  rexMap.set('jpg', /(\.jpg)$/i);
  rexMap.set('doc', /(\.doc)$/i);
  rexMap.set('ppt', /(\.ppt)$/i);
  rexMap.set('txt', /(\.txt)$/i);
  rexMap.set('xls', /(\.xls)$/i);
  rexMap.set('gif', /(\.gif)$/i);
  rexMap.set('xml', /(\.xml)$/i);
  rexMap.set('jpeg', /(\.jpeg)$/i);
  rexMap.set('docx', /(\.docx)$/i);
  rexMap.set('tiff', /(\.tiff)$/i);
  rexMap.set('bmp', /(\.bmp)$/i);
  rexMap.set('csv', /(\.csv)$/i);
  rexMap.set('msg', /(\.msg)$/i);
  rexMap.set('pptx', /(\.pptx)$/i);
  return rexMap;
};

export const validFileFormat = (fileName, allowedFormats = []) => {
  let isValidFileFormat = true;
  if (allowedFormats.length > 0) {
    isValidFileFormat = false;
    const regexMap = getRegexMap();
    for (const format of allowedFormats) {
      const regex = regexMap.get(format);
      if (regex.exec(fileName)) {
        isValidFileFormat = true;
        break;
      }
    }
  }
  return isValidFileFormat;
};

export const validFileName = (fileName, regexString) => {
  const rexString = regexString || '^(?!\\s)(?!.*[\\\\/:*?"<>|])[^\\\\/:*?"<>|]{1,255}(?<!\\s)$';
  return new RegExp(rexString).test(fileName);
};

export const maskString = (masKObj) => {
  const {
    stringToMask, maskPattern, from, to,
  } = masKObj;
  // length of maskPattern may not be same as (to - from) --> XXX-XXX-XXXX
  const firstPart = stringToMask.slice(0, Math.max(0, from - 1));
  const secondPart = stringToMask.slice(Math.max(0, to));
  const maskedString = `${firstPart}${maskPattern}${secondPart}`;
  return maskedString;
};

export const combineDataFields = (fieldsToCombine, dataObject) => {
  let newField = '';
  fieldsToCombine.forEach((field) => {
    if (!field.isStatic) {
      const fieldValue = getVal(dataObject, field.key);
      if (typeof fieldValue === 'string' && fieldValue) {
        const trimmedValue = fieldValue.trim();
        newField += field.separator && newField !== '' ? `${field.separator}${trimmedValue}` : trimmedValue;
      }
    } else {
      newField += field.separator && newField !== '' ? `${field.separator}${field.isStatic}` : field.isStatic;
    }
  });
  return newField;
};

export const formatUnFormatString = (string, formatPattern, format = true) => {
  // formatPattern contains reverse
  // reverse string, separate out format from formatPattern ####-
  // 1234567890 <---> ###-###-#### <---> 123-456-7890
  // 1234567890 <---> reverse string 0987654321 <--> 0987-654321
  let isReverse = false;
  if (formatPattern && formatPattern.includes('Reverse')) {
    // formatPattern ####-Reverse
    isReverse = true;
    formatPattern = formatPattern.replace('Reverse', ''); // ####-
    // reverse input string
    string = [...string].reverse().join('');
  }

  let finalString = '';
  for (const char of formatPattern) {
    if (string.length === 0) break;
    if (char === '#') {
      finalString += string[0];
      string = string.slice(1);
    } else if (char !== '#' && format) {
      finalString += char;
    } else {
      string = string.slice(1);
    }
  }
  if (string.length > 0) {
    finalString += !isReverse && !format ? string.slice(1) : `${string}`;
  }
  if (isReverse) {
    finalString = [...finalString].reverse().join('');
  }
  return finalString;
};

export const getCookies = () => document.cookie;

export const getUniqueCode = () => {
  const hashTable = ['A', 'B', 'C', 'D', 'E', 'F', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  const UniqueCode = [];
  /* eslint-disable-next-line no-plusplus -- need */
  for (let i = 0; i < 15; i++) {
    /* eslint-enable-next-line no-plusplus -- need */
    UniqueCode[i] = hashTable[Math.ceil(Math.random() * hashTable.length - 1)];
  }
  return UniqueCode.join('');
};

export const pdfBlobConversion = (b64Data, contentType) => {
  const sliceSize = 512;
  const byteCharacters = window.atob(b64Data);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    /* eslint-disable-next-line no-plusplus -- need */
    for (let i = 0; i < slice.length; i++) {
      /* eslint-enable-next-line no-plusplus -- need */
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const generateAdditionalTables = (
  dataToProcess, tableTemplates, isOrder = false) => {
  const tables = [];
  // let tables = {};
  // Iterate over all the data elements to create tables out of them
  if (dataToProcess && dataToProcess.length > 0) {
    dataToProcess.forEach((dataEl, index) => {
      // run the table templates on this dataEl
      tableTemplates.forEach((template) => {
        let isTablePossible = false;

        if (template.dynamicRows) {
          const dynamicRowData = getVal(dataEl, template.dynamicRowsFrom) || [];
          template.rows = dynamicRowData.map((item) => {
            const itemData = getVal(dataEl, item);
            const valueKey = `${item} Value`;

            // Determine value based on type
            if (Array.isArray(itemData)) {
              dataEl[valueKey] = itemData.join(',');
            } else if (typeof itemData === 'object' && itemData !== null) {
              dataEl[valueKey] = JSON.stringify(itemData);
            } else {
              dataEl[valueKey] = itemData;
            }

            return {
              rowName: item,
              rowFields: [valueKey],
            };
          });
        }
        // decide if we have to run this template or not for this data element -->
        // if yes, means table needs to be created
        switch (template.runConditions.type) {
          case 'isKeyPresent':
            if (Object.prototype.hasOwnProperty.call(dataEl, template.runConditions.selectKey)) {
              isTablePossible = true;
            }
            break;
          default: isTablePossible = false;
        }
        if (isTablePossible) {
          const table = [];
          template.rows.forEach((row) => {
            const currTableRow = [];
            let entryIsPresent = false;
            row.rowFields.forEach((fieldId) => {
              if (Object.prototype.hasOwnProperty.call(dataEl, fieldId)) {
                const fieldValue = getVal(dataEl, fieldId);
                if (Array.isArray(fieldValue)) {
                  currTableRow.push(fieldValue.join(','));
                } else if (typeof fieldValue === 'object' && fieldValue !== null) {
                  currTableRow.push(JSON.stringify(fieldValue));
                } else {
                  currTableRow.push(fieldValue != null ? String(fieldValue) : '');
                }
                entryIsPresent = true;
              } else {
                currTableRow.push('');
              }
            });
            if (entryIsPresent) {
              if (row.rowName) {
                currTableRow.unshift(row.rowName);
              }
              table.push(currTableRow);
            }
          });

          let { tableLabel } = template;
          const { tableType } = template;
          if (template.addIndexToLabel) {
            tableLabel += index + 1;
          }
          let tableIndex = -1;
          if (tableType && tableType === 'group') {
            tableIndex = tables.findIndex((obj) => tableLabel in obj);
          }
          if (tableIndex === -1) {
            // it's an new table and at least one row is present
            if (table.length > 0) {
              if (template.headers && template.headers.length > 0) {
                // headers are present for this table
                table.unshift(template.headers);
              }

              tables.push({ [tableLabel]: table });
            }
          } else {
            // table with given tableId is already present.
            tables[tableIndex][tableLabel] = [...tables[tableIndex][tableLabel], ...table];
          }
        }
      });
    });
  }

  if (isOrder) {
    const orderedTables = [];
    tableTemplates.forEach((template) => {
      const tableData = tables.find((table) => template.tableLabel in table);
      if (tableData) {
        orderedTables.push(tableData);
      }
    });

    return orderedTables;
  }

  return tables;
};

export const parseHtml = (htmlString) => {
  const cleanHtmlString = DOMPurify.sanitize(htmlString,
    { USE_PROFILES: { html: true }, ADD_ATTR: ['target'] });
  const html = parse(cleanHtmlString);
  return html;
};

export const createCompositeKeyForEntityRow = (dataObj) => {
  let compostieKey = '';
  Object.keys(dataObj).forEach((key) => {
    compostieKey += dataObj[key];
  });

  return compostieKey;
};

export const blobToBase64 = (blob) => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise((resolve) => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};

export const getPageName = (market, page) => {
  switch (market) {
    case 'merchSmallShop_en_US':
      switch (page) {
        case 'page1':
          return 'SS-Marketing-Lead-Form';
        case 'thankyou':
          return 'SS-Marketing-Lead-Form-Thank-You';
        default:
          return '';
      }
    default:
      return '';
  }
};

export const convertFullToHalfWidth = (str) => str.replace(
  /[\uFF01-\uFF5E]/g,
  (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xFEE0)
);

export const getLength = (obj) => obj.length;

export const getObjectLength = (obj) => Object.keys(obj).length;

export const getPlainUuid = () => {
  let tempId = uuid();
  tempId = tempId.replaceAll('-', '');
  return tempId;
};

export const getUniqueFileId = (docId, fileName) => `${docId}_${getPlainUuid()}_${fileName.replace(/\s/g, '')}`;

export const validateMatch = (field1, field2) => field1 === field2;

export const convertStringToDate = (dateStr) => new Date(dateStr);

export const getFutureDateBasedOnMonths = (dateStr, months) => {
  const date = new Date(dateStr);
  date.setMonth(date.getMonth() + months);
  return date;
};

export const patternCheck = (value) => {
  const pattern = /^[\d,]+$/;
  if (typeof value === 'string' && pattern.test(value)) {
    value = value.replace(/,/g, '');
    return value;
  }
  return value;
};

export const calculateAgeInYears = (selectedDate) => {
  const today = new Date();
  let age = today.getFullYear() - selectedDate.getFullYear();
  const monthDiff = today.getMonth() - selectedDate.getMonth();
  if ((monthDiff === 0 && today.getDate() < selectedDate.getDate()) || monthDiff < 0) {
    age -= 1;
  }
  return age;
};

export const generateMagicNumber = (digit) => {
  const AlphaNumericString = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    + '0123456789'
    + 'abcdefghijklmnopqrstuvxyz';
  let sb = '';

  for (let i = 0; i < digit; i += 1) {
    const index = Math.ceil(AlphaNumericString.length * Math.random());
    sb += AlphaNumericString.charAt(index);
  }
  return sb;
};

export const getCurrentPage = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get('page') || '';
};

export const getNewSearchString = (newPageNumber) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  urlSearchParams.set('page', newPageNumber);
  return `?${urlSearchParams.toString()}`;
};

export const isValidUrl = (url) => {
  /* eslint-disable no-new -- need */
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
  /* eslint-enable no-new -- need */
};

export const caculateGiftCardAmounts = (giftCards) => {
  // to calculate shipping fees and total amount
  let totalAmount = 0; // amount of current giftcard
  let totalNumberOfGifts = 0;
  giftCards.forEach((entity) => {
    totalAmount += Number(entity.subTotalNum);
    totalNumberOfGifts += Number(entity.JapanGCOrderInfo_noofcards_321345sa13);
  });
  const fract = Math.ceil(totalNumberOfGifts / 10);
  const shippingFee = fract * 690;
  totalAmount += shippingFee; // add shipping fees to total amount
  return { totalAmount, shippingFee };
};

export const getMetaData = (dataKeysObj, dataObj) => {
  const metaDataObj = {};
  Object.keys(dataKeysObj).forEach((key) => {
    // if key includes Default-- then it is a default value
    if (key.includes('Default--')) {
      const defaultVal = key.split('--')[1];
      metaDataObj[defaultVal] = dataKeysObj[key];
    } else {
      const val = getVal(dataObj, dataKeysObj[key]);
      if (val) {
        metaDataObj[key] = val;
      }
    }
  });
  return metaDataObj;
};

// Get the current date in ISO format
export const getCurrentDate = () => {
  const now = new Date();
  const isoDate = now.toISOString();
  return isoDate;
};

// Generate the file name for S3 using the predefined fileNameParameters in cuid json
export const generateS3FileName = (arrObject, parameters) => {
  let filename = '';
  parameters.forEach((parameter, index) => {
    filename += `${getVal(arrObject, parameter)}${(index + 1) !== parameters.length ? '_' : ''}`;
  });
  return filename;
};

export const convertFileSizeToMB = (fileSizeBytes) => {
  let fileSizeMB = fileSizeBytes / 1e6;
  fileSizeMB = Math.trunc(fileSizeMB * 10000) / 10000;
  return fileSizeMB;
};

export const getIndividualTableMetaData = (props) => {
  const {
    tableId, dataKeysObj, fileKeysObj, dataObj, fileInfoObj,
  } = props;
  const fileMetaDataObjects = [];
  if (fileInfoObj && fileInfoObj.length > 0) {
    // first get all the fileIds from this table
    const filesFromTable = fileInfoObj.filter(
      (fileObj) => fileObj.fileFrom === tableId
    );
    if (filesFromTable.length > 0) {
      let commonMetaData = {};
      /**
       * dataKeysObject creates a common meta data for all the files in the table
       */
      if (dataKeysObj && getObjectLength(dataKeysObj) > 0) {
        commonMetaData = getMetaData(dataKeysObj, dataObj);
      }

      /**
       * fileKeysObject creates a separate meta data for each file in the table
       * So if fileKeysObject is present then -->
       *     we have to add each file as a separate
       *     fileMetaDataObjects e.g [file1Object,file2Object]
       *
       * If fileKeysObject is not present then -->
       *     we have to add all the files under a single fileMetaDataObject
       *     e.g. [fileObject] where fileObject contains commonMetaData
       *     and fileIds array with all the files
       */
      if (fileKeysObj && getObjectLength(fileKeysObj) > 0) {
        filesFromTable.forEach((file) => {
          const fileMetaData = getMetaData(fileKeysObj, file);
          fileMetaData.fileIds = [file.fileId];
          // creating separate fileMetaDataObject for each file
          fileMetaDataObjects.push({ ...commonMetaData, ...fileMetaData });
        });
      } else {
        commonMetaData.fileIds = filesFromTable.map((file) => file.fileId);
        fileMetaDataObjects.push(commonMetaData);
      }
    }
  }
  return fileMetaDataObjects;
};

export const addHeader = (name, content) => {
  const headTag = document.querySelectorAll('HEAD')[0];
  const charsetTag = document.createElement('META');
  charsetTag.setAttribute('name', name);
  charsetTag.setAttribute('content', content);
  headTag.appendChild(charsetTag);
};
export const createFormForGetRedirection = (formId, redirectURL) => {
  const form = document.createElement('form');
  document.body.appendChild(form);
  form.method = 'get';
  form.action = redirectURL;
  form.id = formId;
  form.target = '_self';
};

export const createFormForPostRedirection = (formId, redirectURL) => {
  const form = document.createElement('form');
  document.body.appendChild(form);
  form.method = 'post';
  form.action = redirectURL;
  form.id = formId;
  form.target = '_self';
};
export const createInputForPostRedirection = (name, value, formId) => {
  const input = document.createElement('input');
  const form = document.querySelector(`#${formId}`);
  input.type = 'hidden';
  input.name = name;
  input.value = value;
  form.appendChild(input);
};

export const getCallRequestOptions = (jId) => ({
  defer: true,
  method: 'GET',
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
    traceId: uuid(),
    journeyId: jId,
  },
});

/**
 * Encrypts a payload object to a base64-encoded string.
 * JSON.stringify is applied first, then the result is base64-encoded.
 * Uses encodeURIComponent + unescape to safely handle unicode characters
 * (e.g. file names with accents or special characters) before encoding.
 * Use this for all POST request bodies except ReadDigitalAssets.v1.
 * @param {object} payload - The payload object to encrypt
 * @returns {string} base64-encoded payload string
 */
export const encryptPayload = (payload) => {
  try {
    if (process.env.NODE_ENV === 'development') {
      // Development environment may have issues with base64 encoding unicode characters,
      // so skip encoding to avoid errors and make debugging easier.
      // In production, we can safely encode the payload.
      return JSON.stringify(payload);
    }
    // unescape+encodeURIComponent converts unicode to a Latin-1 safe string
    // so base64Encode (btoa) never throws on non-ASCII characters
    return base64Encode(unescape(encodeURIComponent(JSON.stringify(payload))));
  } catch (e) {
    // last-resort fallback — should not normally be reached
    return JSON.stringify(payload);
  }
};

export const postCallRequestOptions = (jId, payload) => {
  const payloadBody = {
    head: {
      traceId: uuid(),
      journeyId: jId,
      span: 'iForm6513',
    },
    body: payload,
  };
  return {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: encryptPayload(payloadBody),
  };
};

export const normalizeAndDecode = (paramValue) => {
  if (!paramValue) {
    return '';
  }
  // if paramValue has empty spaces then I have replace them by +
  const normalizedValue = paramValue.replace(/ /g, '+');
  // Decode the normalized value
  const decodedValue = decodeURIComponent(normalizedValue);
  return decodedValue;
};

export const base64ToBlobConversion = (b64Data, contentType) => {
  const sliceSize = 512;
  const byteCharacters = window.atob(b64Data);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    /* eslint-disable-next-line no-plusplus -- need */
    for (let i = 0; i < slice.length; i++) {
      /* eslint-enable-next-line no-plusplus -- need */
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const getMIMEType = (base64) => {
  const signatures = {
    JVBERi0: 'application/pdf',
    R0lGODdh: 'image/gif',
    R0lGODlh: 'image/gif',
    iVBORw0KGgo: 'image/png',
    '/9j/': 'image/jpg',
  };

  let mimeType = null;
  Object.keys(signatures).forEach((s) => {
    if (base64.indexOf(s) === 0) {
      mimeType = signatures[s];
    }
  });
  return mimeType;
};

export const chunkString = (str, len) => {
  const size = Math.ceil(str.length / len);
  const r = new Array(size);
  let offset = 0;

  /* eslint-disable-next-line no-plusplus -- desc */
  for (let i = 0; i < size; i++) {
    /* eslint-disable-next-line unicorn/prefer-string-slice -- desc */
    r[i] = str.substr(offset, len);
    offset += len;
  }

  return r;
};

export const combineValuesWithSepartors = (stringsToCombine, separtors) => {
  let combinedString = '';
  for (const [i, element] of stringsToCombine.entries()) {
    combinedString += element;
    if (i < separtors.length) {
      combinedString += separtors[i];
    }
  }
  return combinedString;
};

export const getValuesFromDataObject = (dataObject, keys) => {
  const values = [];
  keys?.forEach((key) => {
    const value = getVal(dataObject, key);
    if (value || (value === 0)) {
      values.push(value);
    } else {
      values.push('');
    }
  });
  return values;
};

export const checkValidRange = (stringVal, allowedRanges, subStringRange) => {
  const { from, to } = subStringRange;
  const subString = stringVal.slice(from - 1, to);
  return allowedRanges.some((range) => subString === range);
};

export const formatDate = (date, format, locale) => date.toLocaleDateString(locale, format);

export const updateToCamelCase = (str) => str?.split(' ').map((word, index) => {
  // If it is the first word make sure to lowercase all the chars.
  if (index === 0) {
    return word.toLowerCase();
  }
  // If it is not the first word only upper case the first char and lowercase the rest.
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}).join('');

export const getValueType = (value) => {
  let returnVal = '';
  switch (typeof value) {
    case 'object':
      returnVal = typeof value;
      if (Array.isArray(value)) {
        returnVal = 'array';
      }
      break;
    default:
      returnVal = typeof value;
  }
  return returnVal;
};

export const isObjectEmpty = (obj) => Object.keys(obj).length === 0 && obj.constructor === Object;

export const checkIfValExist = (id, dataObject) => {
  if (dataObject[id]) {
    switch (typeof dataObject[id]) {
      case 'string':
        return dataObject[id] !== '';
      case 'boolean':
        return !!dataObject[id];
      case 'object':
        if (Array.isArray(dataObject[id])) {
          return dataObject[id].length > 0;
        }
        return !isObjectEmpty(dataObject[id]);
      default:
        return dataObject[id] !== '';
    }
  }
  return false;
};

export const checkIfValueExist = (ids, dataObject, uncheckedValue = false) => ids.some((id) => {
  if (dataObject[id]) {
    switch (typeof dataObject[id]) {
      case 'string':
        return !uncheckedValue || dataObject[id] !== String(uncheckedValue);
      case 'boolean':
        return !!dataObject[id];
      case 'object':
        if (Array.isArray(dataObject[id])) {
          return dataObject[id].length > 0;
        }
        return !isObjectEmpty(dataObject[id]);
      default:
        return dataObject[id] !== '';
    }
  }
  return false;
});

export const checkIfMandatoryValidationExists = (validations) => validations.some((validation) => validation.type === 'mandatoryField');

export const stringOperation = (operation, value) => {
  if (operation) {
    switch (operation) {
      case 'camelCase':
        value = updateToCamelCase(value);
        break;
      default:
        break;
    }
  }
  return value;
};

export const encodeToBase64 = (str) => {
  try {
    return base64Encode(str);
  } catch (e) {
    // handle error
    return null;
  }
};

export const removeTabSpaces = (obj) => {
  if (typeof obj !== 'object' || obj === null) {
    // If it's not an object or is null, return it as is.
    // If it's a string, replace tabs.
    if (typeof obj === 'string') {
      return obj.replace(/\t/g, ' '); // Replace all tab characters
    }
    return obj;
  }

  if (Array.isArray(obj)) {
    // If it's an array, iterate over its elements and apply the function recursively.
    return obj.map((item) => removeTabSpaces(item));
  }

  // If it's an object, iterate over its keys and apply the function recursively to values.
  const newObj = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      newObj[key] = removeTabSpaces(obj[key]);
    }
  }
  return newObj;
};

export const addToStaticTable = (props, tableData) => {
  const {
    fieldId, value, dataObject, functionObject,
  } = props;
  const { formSubmissionPayload = {} } = dataObject;
  const { setFormSubmissionPayload } = functionObject;
  const newTableData = { dlsId: fieldId, dlsValue: value, ...tableData };
  const staticTableData = formSubmissionPayload.staticTableData || [];

  if (value) {
    // add if the value is not empty
    if (staticTableData.length === 0) {
      staticTableData.push(newTableData);
    } else {
      const existingIndex = staticTableData.findIndex((item) => item.dlsId === fieldId);

      if (existingIndex === -1) {
        staticTableData.push(newTableData);
      } else {
        staticTableData[existingIndex] = newTableData;
      }
    }
  } else if (staticTableData.length > 0) {
    // remove the value from the table data
    const existingIndex = staticTableData.findIndex((item) => item.dlsId === fieldId);
    if (existingIndex !== -1) {
      staticTableData.splice(existingIndex, 1);
    }
  }

  formSubmissionPayload.staticTableData = staticTableData;
  setFormSubmissionPayload({ ...formSubmissionPayload });
};

export const formatDateByPattern = (dateStr, inputDateFormat, outputDateFormat) => {
  const formatParts = inputDateFormat.match(/(YYYY|MM|DD)/g);
  const valueParts = dateStr.match(/\d+/g);
  if (!formatParts || !valueParts
    || formatParts.length !== valueParts.length
  ) {
    return 'Invalid format or input date';
  }
  const dateMap = {};
  formatParts.forEach((part, index) => {
    dateMap[part] = valueParts[index];
  });

  return outputDateFormat.replace(/YYYY|MM|DD/g, (match) => dateMap[match]);
};

export const dateFormatChange = (operation, body) => {
  if (operation?.dateFields) {
    operation.dateFields.forEach((dateField) => {
      if (dateField?.inputDateFormat && dateField?.outputDateFormat) {
        if (body[dateField.field]) {
          body[dateField.field] = formatDateByPattern(body[dateField.field],
            dateField?.inputDateFormat,
            dateField?.outputDateFormat);
        }
      }
    });
  }
};

export const spreadEntityDataAndAddToPayload = (operation, functionObj) => {
  const spreadPayload = {};
  const ObjToSpread = functionObj.entityData;
  const objGroupCount = new Map();

  if (operation?.tables) {
    operation.tables.forEach((table) => {
      if (table?.tableId && ObjToSpread[table.tableId]) {
        ObjToSpread[table.tableId].forEach((obj) => {
          if (table?.dateFields
            && table?.dateFields.length > 0) {
            if (table?.inputDateFormat && table?.outputDateFormat) {
              table?.dateFields.forEach((field) => {
                if (obj[field]) {
                  obj[field] = formatDateByPattern(obj[field],
                    table?.inputDateFormat,
                    table?.outputDateFormat);
                }
              });
            }
          }
          let suffixArrays = [''];
          if (table.suffixKey) {
            suffixArrays = obj[table.suffixKey].split(',')
              .map((val) => val.trim().replaceAll(/\s+/g, '_'));
          }
          suffixArrays.forEach((suffix) => {
            const countKey = `${table.tableId}_${suffix}`;

            if (objGroupCount.has(countKey)) {
              objGroupCount.set(countKey, objGroupCount.get(countKey) + 1);
            } else {
              objGroupCount.set(countKey, 1);
            }
            const objGroupIndex = objGroupCount.get(countKey);

            if (!table?.maxSuffixBase
              || (table?.maxSuffixBase
                && objGroupIndex <= table?.maxSuffixBase
              )
            ) {
              if (suffix !== '') {
                suffix = `_${suffix}`;
              }
              Object.keys(obj).forEach((key) => {
                spreadPayload[`${key}_${objGroupIndex}${suffix}`] = obj[key];
              });
            }
          });
        });
      }
    });
  }
  return spreadPayload;
};

export const handleMissingKeyToS3FileObjects = (payloadBody, addS3ObjectKeysToOtherObjects) => {
  const tempS3Details = JSON.parse(payloadBody.s3FileDetails);
  const keyIds = [];
  const updatedS3Details = [];
  const keyNotExistIndex = [];
  if (payloadBody?.entityData) {
    const tempEntityData = JSON.parse(payloadBody.entityData);
    addS3ObjectKeysToOtherObjects.forEach((keyObj) => {
      const keyValues = [];
      tempEntityData?.legalEntity.forEach((entityObj) => {
        if (entityObj[keyObj.keyToCheck]
          && keyValues.indexOf(entityObj[keyObj.keyToCheck]) === -1) {
          keyValues.push(entityObj[keyObj.keyToCheck]);
          keyIds.push({
            keyToAdd: keyObj.keyToAdd,
            value: entityObj[keyObj.keyToCheck],
          });
        }
      });
    });
  }

  if (keyIds.length === 0) {
    return payloadBody;
  }

  keyIds.forEach((keyId) => {
    tempS3Details.forEach((fileObj, index) => {
      if (fileObj[keyId.keyToAdd] === undefined) {
        updatedS3Details.push({ ...fileObj, [keyId.keyToAdd]: keyId.value });
      } else if (keyNotExistIndex.indexOf(index) === -1) {
        keyNotExistIndex.push(index);
        updatedS3Details.push(fileObj);
      }
    });
  });

  payloadBody.s3FileDetails = JSON.stringify(updatedS3Details);
  return payloadBody;
};

export const getValsToArray = (dataPaths, dataObject) => dataPaths.reduce((result, path) => {
  const value = getVal(dataObject, path);
  if (value) {
    if (Array.isArray(value)) {
      return [...result, ...value];
    }

    return [...result, value];
  }
  return result;
}, []);

/* eslint-disable max-params -- need */
export const evaluateMemberFilter = (filter, type, eligible = false, breakLoop = false) => {
  const allowedValues = filter.allowedValues
    ? filter.allowedValues
    : null;
  const notAllowedValues = filter.notAllowedValues
    ? filter.notAllowedValues
    : null;
  if (notAllowedValues && notAllowedValues.includes(type)) {
    eligible = false;
    breakLoop = true;
    return { eligible, breakLoop }; // breaks loop
  }
  if (
    (allowedValues && allowedValues.includes(type))
    || (notAllowedValues && !notAllowedValues.includes(type))
  ) {
    eligible = true;
    breakLoop = false;
  }
  return { eligible, breakLoop };
};
/* eslint-enable max-params -- need */

export const mapArraysToObjectsByIndex = (inputData) => {
  const {
    arrayOne, arrayTwo, arrayOneKey, arrayTwoKey,
  } = inputData;
  if (arrayOne.length !== arrayTwo.length) {
    return []; // or throw an error, depending on how you want to handle this case
  }
  return arrayOne.map((item, index) => ({ [arrayOneKey]: item, [arrayTwoKey]: arrayTwo[index] }));
};
/* eslint-enable no-restricted-syntax -- need */
